import { changeCampaignLineStatus } from '../../actions';
import { connectEditor } from '../../connect-editor';
import { campaignLineStatuses } from '../../constants';
import ProductLockButtonComponent from './ProductLockButton';
import ProductStatusChangeButtonComponent from './ProductStatusChangeButton';

const { DRAFT, READY, PUSHED, LOCKED } = campaignLineStatuses;

function getStatus(campaignLinesById, campaignLineIds) {
  const lines = campaignLineIds.map(id => campaignLinesById[id]);
  if (lines.some(({ status }) => status === PUSHED)) {
    return PUSHED;
  }
  if (lines.some(({ status }) => status === LOCKED)) {
    return LOCKED;
  }
  if (lines.some(({ status }) => status === DRAFT)) {
    return DRAFT;
  }
  if (lines.some(({ status }) => status === READY)) {
    return READY;
  }
  return campaignLinesById[campaignLineIds[0]].status;
}

const mapStateToProps = ({ campaignLinesById }, { campaignLineIds }) => {
  return {
    status: getStatus(campaignLinesById, campaignLineIds),
  };
};

const mapDispatchToProps = (dispatch, { campaignLineIds }) => ({
  onStatusChange(status) {
    return dispatch(changeCampaignLineStatus(campaignLineIds, status));
  },
});

export const ProductStatusChangeButton = connectEditor(
  mapStateToProps,
  mapDispatchToProps,
)(ProductStatusChangeButtonComponent);

export const ProductLockButton = connectEditor(
  mapStateToProps,
  mapDispatchToProps,
)(ProductLockButtonComponent);
